import React from "react";
import "./style.scss";
import type { ModalProps } from "./types";
import {
  Backdrop,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
  Typography,
} from "@mui/material";
import _ from "lodash";
import { useMaterialUIController } from "context";
import { TransitionProps } from "@mui/material/transitions";
import { IconMessageDots, IconSquareXFilled, IconUserOff, IconCancel } from "@tabler/icons-react";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ModalComponent: React.FC<ModalProps> = (props: ModalProps) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  return (
    <>
      <Dialog
        TransitionComponent={Transition}
        fullScreen={props?.esFullScreen}
        open={props?.isOpen || false}
        onClose={props?.handleClose}
        maxWidth={props?.size || "md"}
        fullWidth={_.isEmpty(props?.size)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            backgroundColor: darkMode ? "#3b435f" : "white",
            boxShadow: "none",
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            ...{ color: "#ffff", backgroundColor: "#041d45" },
            ...(props?.esError ? { borderBottom: "solid 4px red" } : {}),
          }}
        >
          <IconMessageDots stroke={2} size={32} />
          {props?.textoHeader ? (
            <Typography variant="h5" sx={{ color: "#fff" }}>
              {props.textoHeader}
            </Typography>
          ) : null}
          <IconSquareXFilled size={32} onClick={props?.handleClose} className="close-icon-hover" />
        </DialogTitle>
        {props?.title ? (
          <DialogTitle id="alert-dialog-title" sx={{ color: darkMode ? "white" : "#344767" }}>
            {props?.title}
          </DialogTitle>
        ) : null}
        <DialogContent style={{ color: darkMode ? "white" : "black" }}>
          {props?.children}
        </DialogContent>
        <DialogActions
          style={{
            background: "#041d45",
            ...{ color: "#344767" },
            ...(props?.esError ? { borderTop: "solid 2px red" } : {}),
          }}
        >
          {props?.textoFooter ? (
            <Typography variant="h5" sx={{ color: "#fff", mr: "auto", ml: 1 }}>
              {props.textoFooter}
            </Typography>
          ) : null}
          {props?.actions?.map((action, index) => (
            <Button
              key={index}
              onClick={action.handleAction}
              startIcon={action.disabledButton ? <IconCancel stroke={2} /> : action.icon}
              variant="contained"
              disabled={action.disabledButton}
              sx={{
                color: action.textColor || "#fff",
                background: action.disabledButton
                  ? `${"#b0b0b0"} !important`
                  : action.color || "#FF6F59",
                "&:hover": {
                  background: action.disabledButton
                    ? `${"#b0b0b0"} !important`
                    : action.hoverColor || "#a8452e",
                },
                "&:focus": {
                  background: action.disabledButton
                    ? `${"#b0b0b0"} !important`
                    : `${action.hoverColor || "#a8452e"} !important`,
                },
              }}
            >
              {action.title}
            </Button>
          ))}

          {props?.actions ? null : (
            <Button
              onClick={props?.handleAction ? props?.handleAction : props?.handleClose}
              startIcon={
                props?.disabledButtonAction ? <IconCancel stroke={2} /> : props?.iconButtonAction
              }
              variant="contained"
              disabled={props?.disabledButtonAction}
              sx={{
                color: props?.textColorAction || "#fff",
                background: props?.disabledButtonAction
                  ? `${"#b0b0b0"} !important`
                  : props?.colorAction || "#FF6F59",
                "&:hover": {
                  background: props?.disabledButtonAction
                    ? `${"#b0b0b0"} !important`
                    : props?.hoverColorAction || "#a8452e",
                },
                "&:focus": {
                  background: props?.disabledButtonAction
                    ? `${"#b0b0b0"} !important`
                    : `${props.hoverColorAction || "#a8452e"} !important`,
                },
              }}
            >
              {props?.titleButtonAction ? props?.titleButtonAction : "Minimizar"}
            </Button>
          )}
        </DialogActions>
        <Backdrop style={{ zIndex: 1000, color: "#fff" }} open={props?.procesando || false}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Dialog>
    </>
  );
};

export default ModalComponent;
